import { render, staticRenderFns } from "./SupplierAccountingStats.vue?vue&type=template&id=75e8fecf&scoped=true"
import script from "./SupplierAccountingStats.vue?vue&type=script&lang=js"
export * from "./SupplierAccountingStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e8fecf",
  null
  
)

export default component.exports